/* eslint-disable */
<template>
  <div class="home-page">
    <vue-basic-alert :duration="400" ref="alert" />

    <!-- Hero Banner -->
    <div class="hero-banner">
      <div class="hero-content">
        <p class="hero-label">Welcome | ආයුබෝවන්</p>
        <h1 class="hero-title">Local Government<br>Online Payment System</h1>
        <p class="hero-sub">පළාත් පාලන මාර්ගගත ගෙවීම් කළමනාකරණ පද්ධතිය</p>
      </div>
      <div class="hero-badge">
        <span>24/7</span>
        <span class="hero-badge-sub">Online</span>
      </div>
    </div>

    <!-- Thank You Section (only if paid) -->
    <div v-if="userNic !== null && receipt !== null" class="thank-section">

      <!-- Success Card -->
      <div class="success-card">
        <div class="success-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <div class="success-text">
          <h2 class="success-title">Payment Successful!</h2>
          <p class="success-sub">Your transaction has been processed. Please save or download your receipt below.</p>
        </div>
        <button @click="generatePDF('receipt')" class="download-btn">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          Download Receipt PDF
        </button>
      </div>

      <!-- Receipt -->
      <div class="receipt-wrapper" id="receipt">
        <div class="receipt-card">

          <!-- Receipt Header -->
          <div class="receipt-header">
            <div class="receipt-gov-badge">LG</div>
            <div class="receipt-header-info">
              <span class="receipt-system-title">Local Government Online Payment Management System</span>
              <span class="receipt-address" v-if="theSabhaData && theSabhaData[0]">{{ theSabhaData[0].sb_address }}</span>
              <span class="receipt-contact" v-if="theSabhaData && theSabhaData[0]">
                Tel: {{ theSabhaData[0].sb_contact }} &nbsp;|&nbsp; Fax: {{ theSabhaData[0].fax }}
              </span>
            </div>
            <div class="receipt-meta">
              <div class="receipt-invoice">
                <span class="inv-label">Invoice No.</span>
                <span class="inv-num">{{ receipt }}</span>
              </div>
              <div class="receipt-datetime">{{ new Date().toLocaleString() }}</div>
            </div>
          </div>

          <div class="receipt-body">
            <h3 class="receipt-type-label">Payment Receipt</h3>

            <!-- ── SHOP RENT ── -->
            <template v-if="paytype == 'shoprent'">
              <div class="info-grid">
                <div class="info-field">
                  <span class="info-label">NIC | හැඳුනුම්පත් අංකය</span>
                  <span class="info-value" v-if="matchUser">{{ matchUser.cus_nic }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Name | නම</span>
                  <span class="info-value" v-if="matchUser">{{ matchUser.cus_name }}</span>
                </div>
                <div class="info-field full-span">
                  <span class="info-label">Remarks | ගෙවීම් විස්තරය</span>
                  <span class="info-value" v-if="rentData && rentData[0]">{{ rentData[0].rent_description }}</span>
                </div>
              </div>

              <!-- Shop Rent Table -->
              <div class="table-wrap">
                <table class="data-table">
                  <thead>
                    <tr>
                      <th>Year-Month</th>
                      <th>Market / Street</th>
                      <th>Shop No.</th>
                      <th>Rent (Rs.)</th>
                      <th>Fine (Rs.)</th>
                      <th>Arrears (Rs.)</th>
                      <th>Total (Rs.)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in rentData" :key="r.rent_id">
                      <td>{{ r.rent_year }} - {{ getMonthName(r.rent_month) }}</td>
                      <td>{{ r.place }}</td>
                      <td>{{ r.rent_shop_no }}</td>
                      <td>{{ r.rent_price }}</td>
                      <td>{{ r.rent_fine }}</td>
                      <td>{{ r.available_arrears }}</td>
                      <td class="amount-cell">{{ r.rent_total_amount }}</td>
                    </tr>
                    <tr class="total-row">
                      <td colspan="3"><b>Total | මුළු එකතුව</b></td>
                      <td><b>{{ rent_total }}</b></td>
                      <td><b>{{ payFinetotal }}</b></td>
                      <td><b>{{ ArrearsTotal }}</b></td>
                      <td class="amount-cell"><b>{{ total }}</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="amount-summary">
                <div class="amount-row"><span class="amount-key">Total Pay Amount</span><span class="amount-val">Rs. {{ Totalpayamount }}</span></div>
                <div class="amount-row"><span class="amount-key">Banking Service Charge</span><span class="amount-val">Rs. {{ bankfee }}</span></div>
                <div class="grand-row"><span class="grand-key">Grand Total</span><span class="grand-val">Rs. {{ grandPayTotal }}</span></div>
              </div>
            </template>

            <!-- ── ASSESSMENT TAX ── -->
            <template v-if="paytype == 'tax'">
              <div class="info-grid" v-if="taxData && taxData[0]">
                <div class="info-field">
                  <span class="info-label">Assessment Owner(s)</span>
                  <span class="info-value">{{ taxData[0].cus_name }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Property Address</span>
                  <span class="info-value">{{ taxData[0].cus_address }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Ward</span>
                  <span class="info-value">{{ taxData[0].ward }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Road / Street</span>
                  <span class="info-value">{{ taxData[0].street }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Assessment / Used No.</span>
                  <span class="info-value">{{ taxData[0].assess_number }} / {{ taxData[0].used_number }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">K Form Reference</span>
                  <span class="info-value">{{ taxData[0].property_id }}</span>
                </div>
                <div class="info-field full-span">
                  <span class="info-label">Description</span>
                  <span class="info-value desc-val">{{ taxData[0].description }}</span>
                </div>
              </div>

              <div class="amount-summary" v-if="taxData && taxData[0]">
                <div class="amount-row"><span class="amount-key">Arrears / Excess Amount</span><span class="amount-val">Rs. {{ taxData[0].excess_arrears }}</span></div>
                <div class="amount-row"><span class="amount-key">Quarter Amount</span><span class="amount-val">Rs. {{ taxData[0].quater_amount }}</span></div>
                <div class="amount-row"><span class="amount-key">Assessment Fine</span><span class="amount-val fine-val">Rs. {{ taxData[0].fine }}</span></div>
                <div class="amount-row"><span class="amount-key">Assessment Discount</span><span class="amount-val discount-val">- Rs. {{ taxData[0].discount }}</span></div>
                <div class="amount-divider"></div>
                <div class="amount-row"><span class="amount-key">Payable Amount</span><span class="amount-val">Rs. {{ taxData[0].paid_amount }}</span></div>
                <div class="amount-row"><span class="amount-key">Banking Service Charge</span><span class="amount-val">Rs. {{ bankfee }}</span></div>
                <div class="grand-row"><span class="grand-key">Grand Total</span><span class="grand-val">Rs. {{ grandPayTotal }}</span></div>
              </div>
            </template>

            <!-- ── OTHER PAYMENT ── -->
            <template v-if="paytype == 'other'">
              <div class="info-grid" v-if="OtherPayData && OtherPayData[0]">
                <div class="info-field">
                  <span class="info-label">NIC | හැඳුනුම්පත් අංකය</span>
                  <span class="info-value" v-if="matchUser">{{ matchUser.cus_nic }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Name | නම</span>
                  <span class="info-value" v-if="matchUser">{{ matchUser.cus_name }}</span>
                </div>
                <div class="info-field full-span">
                  <span class="info-label">Description | ගෙවීම් විස්තරය</span>
                  <span class="info-value">{{ OtherPayData[0].other_pay_description }}</span>
                </div>
              </div>
              <div class="amount-summary">
                <div class="amount-row"><span class="amount-key">Pay Amount</span><span class="amount-val">Rs. {{ OtherPayData && OtherPayData[0] ? OtherPayData[0].other_pay_price : '' }}</span></div>
                <div class="amount-row"><span class="amount-key">Banking Service Charge</span><span class="amount-val">Rs. {{ bankfee }}</span></div>
                <div class="grand-row"><span class="grand-key">Grand Total</span><span class="grand-val">Rs. {{ grandPayTotal }}</span></div>
              </div>
            </template>

            <!-- ── BOOKING ── -->
            <template v-if="paytype == 'booking'">
              <div class="info-grid" v-if="bookingData && bookingData[0]">
                <div class="info-field">
                  <span class="info-label">NIC & Name</span>
                  <span class="info-value" v-if="matchUser">{{ matchUser.cus_nic }} - {{ matchUser.cus_name }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Applicant Name</span>
                  <span class="info-value">{{ bookingData[0].name }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Applicant Address</span>
                  <span class="info-value">{{ bookingData[0].address }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Telephone</span>
                  <span class="info-value">{{ bookingData[0].mobile }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Request Date</span>
                  <span class="info-value">{{ formatDate(bookingData[0].req_date_from) }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Service Type</span>
                  <span class="info-value">{{ bookingData[0].service_type }}</span>
                </div>
              </div>
              <div class="amount-summary">
                <div class="amount-row"><span class="amount-key">Pay Amount</span><span class="amount-val">Rs. {{ bookingData && bookingData[0] ? bookingData[0].amount : '' }}</span></div>
                <div class="amount-row"><span class="amount-key">Banking Service Charge</span><span class="amount-val">Rs. {{ bankfee }}</span></div>
                <div class="grand-row"><span class="grand-key">Grand Total</span><span class="grand-val">Rs. {{ grandPayTotal }}</span></div>
              </div>
            </template>

            <!-- ── WATER BILL ── -->
            <template v-if="paytype == 'water'">
              <div class="info-grid" v-if="WaterPayData">
                <div class="info-field">
                  <span class="info-label">NIC | හැඳුනුම්පත් අංකය</span>
                  <span class="info-value">{{ WaterPayData.customerNic }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Name | නම</span>
                  <span class="info-value">{{ WaterPayData.customerName }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Account Number</span>
                  <span class="info-value">{{ WaterPayData.accountNumber }}</span>
                </div>
                <div class="info-field">
                  <span class="info-label">Billing Month</span>
                  <span class="info-value">{{ formatPayMonth(WaterPayData.paymonth) }}</span>
                </div>
                <div class="info-field full-span">
                  <span class="info-label">Address | ලිපිනය</span>
                  <span class="info-value">{{ WaterPayData.customerAddress }}</span>
                </div>
              </div>

              

              <div class="amount-summary" v-if="WaterPayData && WaterPayData.breakdown">
                <div class="amount-row"><span class="amount-key">Arrears</span><span class="amount-val">Rs. {{ Number(WaterPayData.breakdown.arrears).toFixed(2) }}</span></div>
                <div class="amount-row"><span class="amount-key">Fines</span><span class="amount-val fine-val">Rs. {{ Number(WaterPayData.breakdown.fines).toFixed(2) }}</span></div>
                <div class="amount-row"><span class="amount-key">Current Bill</span><span class="amount-val">Rs. {{ Number(WaterPayData.breakdown.current).toFixed(2) }}</span></div>
                <div class="amount-row"><span class="amount-key">Excess</span><span class="amount-val discount-val">Rs. {{ Number(WaterPayData.breakdown.excess).toFixed(2) }}</span></div>
                <div class="amount-divider"></div>
                <div class="amount-row"><span class="amount-key">Total Paid Amount</span><span class="amount-val">Rs. {{ Number(WaterPayData.paymentAmount).toFixed(2) }}</span></div>
                <div class="amount-row"><span class="amount-key">Banking Service Charge</span><span class="amount-val">Rs. {{ bankfee }}</span></div>
                <div class="grand-row"><span class="grand-key">Grand Total</span><span class="grand-val">Rs. {{ grandPayTotal }}</span></div>
              </div>
            </template>

          </div><!-- /receipt-body -->
        </div><!-- /receipt-card -->
      </div><!-- /receipt-wrapper -->

    </div><!-- /thank-section -->

    <!-- Services Section -->
    <div class="services-section">
      <div class="services-header">
        <div class="services-bar"></div>
        <div>
          <p class="services-label">Our Services</p>
          <h2 class="services-title">What would you like to pay?</h2>
        </div>
      </div>

      <div class="services-grid">

        <!-- Shop Rent -->
        <div class="service-card">
          <div class="service-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
            </svg>
          </div>
          <h3 class="service-title">Shop Rent</h3>
          <p class="service-desc">Pay your monthly shop rent | ඔබගේ කඩ කුලී ගෙවිම සඳහා</p>
          <div v-if="!user">
            <router-link @click="scrollToTop()" to="/login" class="service-btn">Sign In to Pay</router-link>
          </div>
          <div v-else>
            <router-link @click="scrollToTop()" :to="!matchshop.length ? '/thank' : '/shoprentexist'" class="service-btn">
              Shop Rent 
            </router-link>
          </div>
        </div>

        <!-- Assessment Tax -->
        <div class="service-card">
          <div class="service-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
            </svg>
          </div>
          <h3 class="service-title">Assessment Tax</h3>
          <p class="service-desc">Pay your property assessment tax | වරිපනම් බදු ගෙවිම සඳහා</p>
          <div v-if="!user">
            <router-link @click="scrollToTop()" to="/login" class="service-btn">Sign In to Pay</router-link>
          </div>
          <div v-else>
            <router-link @click="scrollToTop()" to="/AssessmentTaxNewNew" class="service-btn">
              Assessment Tax 
            </router-link>
          </div>
        </div>
 <!-- Water Bill Payments -->
        <div class="service-card">
          <div class="service-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
            </svg>
          </div>
          <h3 class="service-title">Water Bill</h3>
          <p class="service-desc">Water Bill payments | වතුර බිල ගෙවීම සඳහා</p>
          <div v-if="!user">
            <router-link @click="scrollToTop()" to="/login" class="service-btn">Sign In to Pay</router-link>
          </div>
          <div v-else>
            <router-link @click="scrollToTop()" to="/water_bill_landing" class="service-btn">Water Bill </router-link>
            <!-- <router-link @click="scrollToTop()" to="/calendar" class="service-btn">Water Bill </router-link> -->
          </div>
        </div>

        <!-- Booking -->
        <div class="service-card">
          <div class="service-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
          </div>
          <h3 class="service-title">Online Booking</h3>
          <p class="service-desc">Book equipment & venues | බැකෝ යන්ත්‍ර, ගලි බව්සර්, ක්‍රීඩාංගන, නගර ශාලාව</p>
          <div v-if="!user">
            <router-link @click="scrollToTop()" to="/login" class="service-btn">Sign In to Book</router-link>
          </div>
          <div v-else>
            <router-link @click="scrollToTop()" to="/onlinebooking" class="service-btn">Booking</router-link>
          </div>
        </div>

        <!-- Other Payments -->
        <div class="service-card">
          <div class="service-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
            </svg>
          </div>
          <h3 class="service-title">Other Payments</h3>
          <p class="service-desc">All other council payments | වෙනත් ඕනෑම ගෙවීමක් සඳහා</p>
          <div v-if="!user">
            <router-link @click="scrollToTop()" to="/login" class="service-btn">Sign In to Pay</router-link>
          </div>
          <div v-else>
            <router-link @click="scrollToTop()" to="/otherpayments" class="service-btn">Other Payments </router-link>
          </div>
        </div>
       

      </div>
    </div>

    <!-- Notice Banner -->
    <div class="notice-banner" v-if="user">
      <div class="notice-icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
      <div class="notice-text">
        <p><b>Click the Profile button above</b> to check your profile. If the local authority you need is not listed, please add it there.</p>
        <p>ඉහතින් පෙන්වන Profile Button එක මත Click කර, ඔබගේ ප්‍රොෆයිලය පරීක්ෂා කර, ඔබට සේවාවන් ලබාගැනීමට අවශ්‍ය සභාවන් ඇත්නම් ඒවා සඳහා එකතු කර ගන්න.</p>
      </div>
    </div>

  </div>
</template>


<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";
import VueBasicAlert from 'vue-basic-alert';
import html2pdf from 'html2pdf.js';

export default {
  name: "Home",
  data() {
    return {
      matchshop: [],
      Nic: '', userNic: null, receipt: '1111', grandPayTotal: 0, bankfee: 0,
      matchUser: undefined,
      ArrearsTotal: 0, total: 0, Totalpayamount: 0, rent_total: 0,
      nexxtArrears: 0, totalfine: 0,
      theSabhaData: [], rentData: [], taxData: [],
      paytype: '', bookingId: '', bookingData: [],
      payFinetotal: 0, fineArrear: 0, ipg: '', OtherPayData: [], WaterPayData: null,
    };
  },
  // created() {
  //   this.getSessionData();
  //   this.getserverdate();
  // },
created() {

  // Restore session first
  if (!sessionStorage.getItem("Userdata")) {

    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    const userdata = localStorage.getItem("Userdata");

    if (token) {
      sessionStorage.setItem("token", token);
    }

    if (user) {
      sessionStorage.setItem("user", user);
    }

    if (userdata) {
      sessionStorage.setItem("Userdata", userdata);
    }
  }

  console.log(
    "Created - Userdata:",
    sessionStorage.getItem("Userdata")
  );

  this.getSessionData();
  this.getserverdate();
},
  computed: {
    ...mapState(["user"]),
  },
//   mounted() {

//   // Restore session from localStorage
//   if (!sessionStorage.getItem("Userdata")) {

//     const token = localStorage.getItem("token");
//     const user = localStorage.getItem("user");
//     const userdata = localStorage.getItem("Userdata");

//     if (token) {
//       sessionStorage.setItem("token", token);
//     }

//     if (user) {
//       sessionStorage.setItem("user", user);
//     }

//     if (userdata) {
//       sessionStorage.setItem("Userdata", userdata);
//     }
//   }

//   console.log(
//     "Restored Userdata:",
//     sessionStorage.getItem("Userdata")
//   );
// },
  methods: {
    ...mapMutations(["setUser"]),

    scrollToTop() { window.scrollTo(0, 0); },

    formatDate(givedate) {
      const date = new Date(givedate);
      return date.toISOString().split('T')[0];
    },

    formatPayMonth(ym) {
      if (!ym) return '';
      const [year, month] = ym.split('-');
      const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1);
      return date.toLocaleString('en-US', { month: 'long', year: 'numeric' });
    },

    getMonthName(monthNumber) {
      const date = new Date(this.serverDate);
      date.setMonth(monthNumber - 1);
      return date.toLocaleString('en-US', { month: 'long' });
    },

    async getMatchshop(cusnic) {
      let shopdetail = await axios.get('/shopdata/' + cusnic);
      this.matchshop = shopdetail.data;
    },

    async MatchUser(usernic) {
      let data = await axios.get('/customersdata/' + usernic);
      this.matchUser = data.data;
    },

    async getserverdate() {
      try {
        const response = await axios.get('/getserverdate');
        this.serverDate = response.data.serverDate;
      } catch (error) {
        console.error("Error fetching server date:", error);
      }
    },

    async getSessionData() {
      window.sessionStorage.removeItem('rentDetails');
      window.sessionStorage.removeItem('shopDataid');
      console.log('Userdata');
console.log(sessionStorage.getItem('Userdata'));

     const rawData = sessionStorage.getItem("Userdata");

        console.log("Userdata Raw:", rawData);

        if (!rawData) {
          console.log("No Userdata found");
          return;
        }

        const data = JSON.parse(rawData);
      if (data) {
        this.Nic = data.Unic;
        await this.getMatchshop(this.Nic);
        await this.MatchUser(this.Nic);
        this.setUser(this.matchUser);
      }

      let url_string = window.location.href;
      let url = new URL(url_string);
      this.userNic = url.searchParams.get("nic");
      this.receipt = url.searchParams.get("receipt");
      this.paytype = url.searchParams.get("type");
      this.bookingId = url.searchParams.get("bId");

      if (this.userNic !== null) {
        await this.MatchUser(this.userNic);
        this.setUser(this.matchUser);

        if (this.receipt !== null) {

          if (this.paytype == 'shoprent') {

            let rents = await axios.get('/shoprentbyinvoice/' + this.receipt + '/' + this.userNic);
            this.rentData = rents.data;
            let Prasabha = this.rentData[0].rent_sabha_code;
            this.theSabhaData = (await axios.get('/PraSabhadata/' + Prasabha)).data;
            this.ipg = this.theSabhaData[0].saba_ipg;
            let totalMonthlyShopRent = 0, Paytotal = 0, totalArrears = 0, fine = 0, finepay = 0;
            for (let x = 0; x < this.rentData.length; x++) {
              totalMonthlyShopRent += parseFloat(this.rentData[x].rent_price || 0);
              Paytotal += parseFloat(this.rentData[x].rent_pay_amount || 0);
              totalArrears += parseFloat(this.rentData[x].available_arrears || 0);
              finepay += parseFloat(this.rentData[x].pay_fine || 0);
              fine += parseFloat(this.rentData[x].rent_fine || 0);
            }
            this.ArrearsTotal = totalArrears.toFixed(2);
            this.total = finepay > 0
              ? (totalMonthlyShopRent + totalArrears + finepay).toFixed(2)
              : (totalMonthlyShopRent + totalArrears).toFixed(2);
            this.Totalpayamount = Paytotal.toFixed(2);
            this.rent_total = totalMonthlyShopRent.toFixed(2);
            this.nexxtArrears = (this.total - Paytotal).toFixed(2);
            this.totalfine = fine.toFixed(2);
            this.payFinetotal = finepay.toFixed(2);
            this.fineArrear = (this.totalfine - this.payFinetotal).toFixed(2);
            this.bankfee = this.ipg == 'BOC'
              ? (parseFloat(this.Totalpayamount) * ((100 / (100 - 1)) - 1)).toFixed(2)
              : (parseFloat(this.Totalpayamount) * 0.01).toFixed(2);
            this.grandPayTotal = (parseFloat(this.bankfee) + parseFloat(this.Totalpayamount)).toFixed(2);

            await this.sendPaymentSms(
            this.rentData[0].rent_sabha_code,
            this.matchUser.cus_contact,
            this.paytype,
            this.receipt
          );
            
          }

          if (this.paytype == 'tax') {
            await this.MatchUser(this.bookingId);
            this.setUser(this.matchUser);
            let arraytax = await axios.get('/getreceiptbill/' + this.receipt + '/' + this.userNic);
            this.taxData = arraytax.data;
            let Prasabha2 = this.taxData[0].sabha;
            this.theSabhaData = (await axios.get('/PraSabhadata/' + Prasabha2)).data;
            this.ipg = this.theSabhaData[0].saba_ipg;
            let taxpayment = 0;
            for (let x = 0; x < this.taxData.length; x++) taxpayment += parseFloat(this.taxData[x].paid_amount || 0);
            this.bankfee = this.ipg == 'BOC'
              ? (parseFloat(taxpayment) * ((100 / (100 - 1)) - 1)).toFixed(2)
              : (parseFloat(taxpayment) * 0.01).toFixed(2);
            this.grandPayTotal = (parseFloat(this.bankfee) + parseFloat(taxpayment)).toFixed(2);

            await this.sendPaymentSms(
              this.taxData[0].sabha,
              this.matchUser.cus_contact,
              this.paytype,
              this.receipt
            );
          }

          if (this.paytype == 'booking') {
            let arrayBooking = await axios.get('/onbookingrequestgid/' + this.bookingId);
            this.bookingData = arrayBooking.data;
            let Prasabha3 = this.bookingData[0].sabha_code;
            this.theSabhaData = (await axios.get('/PraSabhadata/' + Prasabha3)).data;
            this.ipg = this.theSabhaData[0].saba_ipg;
            let bookingPayment = 0;
            for (let i = 0; i < this.bookingData.length; i++) bookingPayment += parseFloat(this.bookingData[i].amount || 0);
            this.bankfee = this.ipg == 'BOC'
              ? (parseFloat(bookingPayment) * ((100 / (100 - 1)) - 1)).toFixed(2)
              : (parseFloat(bookingPayment) * 0.01).toFixed(2);
            this.grandPayTotal = (parseFloat(this.bankfee) + parseFloat(bookingPayment)).toFixed(2);

            // send SMS
            await this.sendPaymentSms(
              this.bookingData[0].sabha_code,
              this.matchUser.cus_contact,
              this.paytype,
              this.receipt
            );
          }

          if (this.paytype == 'other') {
            let arrayOtherPay = await axios.get('/otherpayments/' + this.userNic + '/' + this.receipt);
            this.OtherPayData = arrayOtherPay.data;
            let Prasabha4 = this.OtherPayData[0].other_pay_sabha_code;
            this.theSabhaData = (await axios.get('/PraSabhadata/' + Prasabha4)).data;
            this.ipg = this.theSabhaData[0].saba_ipg;
            let otherPayment = 0;
            for (let i = 0; i < this.OtherPayData.length; i++) otherPayment += parseFloat(this.OtherPayData[i].other_pay_price || 0);
            this.bankfee = this.ipg == 'BOC'
              ? (parseFloat(otherPayment) * ((100 / (100 - 1)) - 1)).toFixed(2)
              : (parseFloat(otherPayment) * 0.01).toFixed(2);
            this.grandPayTotal = (parseFloat(this.bankfee) + parseFloat(otherPayment)).toFixed(2);
             // send SMS
          await this.sendPaymentSms(
            this.OtherPayData[0].other_pay_sabha_code,
            this.matchUser.cus_contact,
            this.paytype,
            this.receipt
          );
          }

          if (this.paytype == 'water') {
            let arrayWaterPay = await axios.get('/water_bill/online-payment/receipt/' + this.receipt);
            // API shape: { status: 'success', data: { ...payment fields..., sabha: {...}, breakdown: {...} } }
            this.WaterPayData = arrayWaterPay.data.data;
            let Prasabha5 = this.WaterPayData.sabha.code;
            this.theSabhaData = (await axios.get('/PraSabhadata/' + Prasabha5)).data;
            this.ipg = this.theSabhaData[0].saba_ipg;
            let waterPayment = parseFloat(this.WaterPayData.paymentAmount || 0);
            this.bankfee = this.ipg == 'BOC'
              ? (parseFloat(waterPayment) * ((100 / (100 - 1)) - 1)).toFixed(2)
              : (parseFloat(waterPayment) * 0.01).toFixed(2);
            this.grandPayTotal = (parseFloat(this.bankfee) + parseFloat(waterPayment)).toFixed(2);
             // send SMS
          await this.sendPaymentSms(
            this.WaterPayData.sabha.code,
            this.WaterPayData.contactNo,
            this.paytype,
            this.receipt
          );
          }
        }
      }
    },
async sendPaymentSms(sabha_code, mobile, paytype, receipt) {
  try {
    // check if SMS already sent for this receipt
    const smsKey = `sms_sent_${receipt}`;
    if (sessionStorage.getItem(smsKey)) {
      console.log("SMS already sent for receipt:", receipt);
      return;
    }

    const sabhaName = this.theSabhaData[0]?.sb_name_en || " ";
    let message = "";

    if (paytype === "shoprent") {
      message = `Dear Customer, your Shop Rent payment of Rs. ${this.grandPayTotal} has been received. Invoice No: ${receipt}. Thank you. - ${sabhaName}, Local Government`;
    } else if (paytype === "tax") {
      message = `Dear Customer, your Assessment Tax payment of Rs. ${this.grandPayTotal} has been received. Invoice No: ${receipt}. Thank you. - ${sabhaName}, Local Government`;
    } else if (paytype === "booking") {
      message = `Dear Customer, your Booking payment of Rs. ${this.grandPayTotal} has been received. Invoice No: ${receipt}. Thank you. - ${sabhaName}, Local Government`;
    } else if (paytype === "other") {
      message = `Dear Customer, your payment of Rs. ${this.grandPayTotal} has been received. Invoice No: ${receipt}. Thank you. - ${sabhaName}, Local Government`;
    } else if (paytype === "water") {
      message = `Dear Customer, your Water Bill payment of Rs. ${this.grandPayTotal} has been received. Invoice No: ${receipt}. Thank you. - ${sabhaName}, Local Government`;
    }

    await axios.post("/send-payment-sms", {
      sabha_code,
      mobile,
      message,
    });

    // mark as sent so refreshes don't resend
    sessionStorage.setItem(smsKey, "1");
    console.log("Payment SMS sent successfully");
  } catch (err) {
    console.error("Payment SMS failed:", err.message);
  }
},
    generatePDF(receipt) {
      const element = document.getElementById(receipt);
      const pdfPromise = new Promise((resolve) => {
        html2pdf(element, {
          margin: 1,
          filename: 'payment_receipt.pdf',
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        }, (pdf) => { resolve(pdf.output('blob')); });
      });
      pdfPromise.then((blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      }).catch((error) => { console.error('Error generating PDF:', error); });
    },
  },
  components: { VueBasicAlert },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

.home-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  color: #1c0f0a;
}

/* ── Hero Banner ── */
.hero-banner {
  background: linear-gradient(135deg, #7c2d12 0%, #c2440a 60%, #ea580c 100%);
  padding: 4rem 9%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;
  position: relative;
  overflow: hidden;
}
.hero-banner::before {
  content: '';
  position: absolute;
  top: -40%; right: -10%;
  width: 50rem; height: 50rem;
  border-radius: 50%;
  background: rgba(255,255,255,0.04);
  pointer-events: none;
}
.hero-content { position: relative; }
.hero-label {
  font-size: 1.2rem; font-weight: 500;
  letter-spacing: 0.14em; text-transform: uppercase;
  color: rgba(255,255,255,0.7); margin: 0 0 0.6rem;
}
.hero-title {
  font-family: 'DM Serif Display', serif;
  font-size: clamp(2.2rem, 4vw, 3.4rem);
  color: #fff; line-height: 1.2; margin: 0 0 0.8rem;
}
.hero-sub { font-size: 1.3rem; color: rgba(255,255,255,0.8); margin: 0; }
.hero-badge {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  width: 8rem; height: 8rem; border-radius: 50%;
  background: rgba(255,255,255,0.12);
  border: 2px solid rgba(255,255,255,0.25);
  flex-shrink: 0;
}
.hero-badge span:first-child { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #fff; line-height: 1; }
.hero-badge-sub { font-size: 1rem; color: rgba(255,255,255,0.75); }

/* ── Thank / Success Section ── */
.thank-section {
  max-width: 900px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
}

.success-card {
  display: flex; align-items: center; gap: 2rem; flex-wrap: wrap;
  background: #fff; border: 1px solid #e5ddd5; border-radius: 1.2rem;
  padding: 2rem 2.4rem; margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(22,101,52,0.10);
  border-left: 5px solid #16a34a;
}
.success-icon {
  width: 5rem; height: 5rem; border-radius: 50%;
  background: linear-gradient(135deg, #166534, #16a34a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.success-icon svg { width: 2.6rem; height: 2.6rem; stroke: #fff; }
.success-text { flex: 1; }
.success-title {
  font-family: 'DM Serif Display', serif; font-size: 2rem;
  color: #14532d; margin: 0 0 0.3rem;
}
.success-sub { font-size: 1.3rem; color: #4a3028; margin: 0; }

.download-btn {
  display: inline-flex; align-items: center; gap: 0.7rem;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #166534, #16a34a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.4rem; font-weight: 600;
  cursor: pointer; box-shadow: 0 4px 14px rgba(22,101,52,0.3);
  transition: all 0.2s; white-space: nowrap;
}
.download-btn svg { width: 1.8rem; height: 1.8rem; }
.download-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(22,101,52,0.4); }

/* ── Receipt Card ── */
.receipt-wrapper { margin-bottom: 2rem; }
.receipt-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; overflow: hidden;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
}

.receipt-header {
  display: flex; align-items: center; gap: 2rem; flex-wrap: wrap;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  padding: 1.8rem 2.4rem;
}
.receipt-gov-badge {
  width: 5rem; height: 5rem; border-radius: 50%;
  background: rgba(255,255,255,0.15); border: 2px solid rgba(255,255,255,0.3);
  color: #fff; font-family: 'DM Serif Display', serif;
  font-size: 1.6rem; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.receipt-header-info { display: flex; flex-direction: column; gap: 0.3rem; flex: 1; }
.receipt-system-title { font-size: 1.05rem; color: rgba(255,255,255,0.75); }
.receipt-address { font-size: 1.3rem; color: #fff; font-weight: 600; }
.receipt-contact { font-size: 1.2rem; color: rgba(255,255,255,0.85); }
.receipt-meta { display: flex; flex-direction: column; align-items: flex-end; gap: 0.4rem; flex-shrink: 0; }
.receipt-invoice { display: flex; flex-direction: column; align-items: flex-end; }
.inv-label { font-size: 1rem; color: rgba(255,255,255,0.7); text-transform: uppercase; letter-spacing: 0.08em; }
.inv-num {
  font-family: 'DM Serif Display', serif; font-size: 1.6rem; color: #fff;
  background: rgba(255,255,255,0.15); padding: 0.2rem 1rem;
  border-radius: 0.4rem; border: 1px solid rgba(255,255,255,0.25);
}
.receipt-datetime { font-size: 1.1rem; color: rgba(255,255,255,0.7); }

.receipt-body { padding: 2.4rem; }
.receipt-type-label {
  font-family: 'DM Serif Display', serif; font-size: 1.8rem;
  color: #7c2d12; margin: 0 0 2rem;
  padding-bottom: 1rem; border-bottom: 2px solid #f0e6de;
}

/* ── Info Grid ── */
.info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1.4rem 2rem; margin-bottom: 2rem; }
.full-span { grid-column: 1 / -1; }
.info-field { display: flex; flex-direction: column; gap: 0.3rem; }
.info-label { font-size: 1.05rem; font-weight: 500; color: #9a8070; text-transform: uppercase; letter-spacing: 0.06em; }
.info-value { font-size: 1.4rem; font-weight: 600; color: #1c0f0a; }
.desc-val { white-space: pre-wrap; font-weight: 400; font-style: italic; color: #4a3028; }

/* ── Data Table ── */
.table-wrap { overflow-x: auto; border-radius: 0.8rem; border: 1px solid #e5ddd5; margin-bottom: 2rem; }
.data-table { width: 100%; border-collapse: collapse; font-size: 1.3rem; }
.data-table th {
  background: #f0ebe3; color: #4a3028; font-weight: 600;
  padding: 1rem 1.2rem; text-align: center; border-bottom: 2px solid #e5ddd5;
  white-space: nowrap;
}
.data-table td { padding: 0.9rem 1.2rem; text-align: center; border-bottom: 1px solid #f0ebe3; }
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover { background: #fdf9f6; }
.amount-cell { text-align: right !important; }
.total-row { background: #f5f0ea; }
.total-row td { border-top: 2px solid #e5ddd5; }

/* ── Amount Summary ── */
.amount-summary {
  background: #faf8f6; border: 1px solid #e5ddd5;
  border-radius: 0.8rem; padding: 1.4rem 1.8rem;
}
.amount-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 0.8rem 0; border-bottom: 1px solid #f0ebe3;
}
.amount-row:last-child { border-bottom: none; }
.amount-key { font-size: 1.3rem; color: #4a3028; }
.amount-val { font-size: 1.3rem; font-weight: 600; color: #1c0f0a; font-variant-numeric: tabular-nums; }
.fine-val { color: #b91c1c; }
.discount-val { color: #15803d; }
.amount-divider { height: 1px; background: #e5ddd5; margin: 0.3rem 0; }
.grand-row {
  display: flex; align-items: center; justify-content: space-between;
  margin-top: 0.8rem; padding: 1.2rem 1.6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-radius: 0.7rem;
}
.grand-key { font-size: 1.4rem; color: rgba(255,255,255,0.85); font-weight: 500; }
.grand-val { font-family: 'DM Serif Display', serif; font-size: 1.9rem; color: #fff; }

/* ── Services Section ── */
.services-section {
  max-width: 1100px;
  margin: 0 auto;
  padding: 4rem 1.5rem;
}
.services-header {
  display: flex; align-items: flex-start; gap: 1.4rem; margin-bottom: 3rem;
}
.services-bar {
  width: 5px; min-height: 60px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.services-label { font-size: 1.2rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.3rem; }
.services-title { font-family: 'DM Serif Display', serif; font-size: 2.4rem; color: #1c0f0a; margin: 0; }

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(22rem, 1fr));
  gap: 1.6rem;
}

.service-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2.4rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
  display: flex; flex-direction: column; gap: 1.2rem;
  transition: all 0.2s;
}
.service-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 28px rgba(100,50,30,0.12);
  border-color: #c2440a;
}

.service-icon {
  width: 5rem; height: 5rem; border-radius: 1rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center;
}
.service-icon svg { width: 2.4rem; height: 2.4rem; stroke: #fff; }

.service-title {
  font-family: 'DM Serif Display', serif; font-size: 1.8rem;
  color: #1c0f0a; margin: 0;
}
.service-desc { font-size: 1.3rem; color: #7a6258; line-height: 1.6; flex: 1; margin: 0; }

.service-btn {
  display: inline-flex; align-items: center; justify-content: center;
  padding: 1rem 1.6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: 0.7rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.35rem; font-weight: 600;
  text-decoration: none; text-align: center;
  box-shadow: 0 3px 10px rgba(124,45,18,0.25);
  transition: all 0.2s;
}
.service-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(124,45,18,0.35);
}

/* ── Notice Banner ── */
.notice-banner {
  display: flex; align-items: flex-start; gap: 1.4rem;
  background: #fff8f0; border-top: 3px solid #c2440a;
  padding: 2rem 9%;
}
.notice-icon {
  width: 3.5rem; height: 3.5rem; flex-shrink: 0;
  color: #c2440a; margin-top: 0.2rem;
}
.notice-icon svg { width: 100%; height: 100%; }
.notice-text p { font-size: 1.3rem; color: #4a3028; line-height: 1.7; margin: 0 0 0.5rem; }
.notice-text p:last-child { margin-bottom: 0; color: #7a6258; }

/* ── Responsive ── */
@media (max-width: 768px) {
  .hero-banner { padding: 3rem 5%; }
  .hero-badge { display: none; }
  .services-section { padding: 3rem 1rem; }
  .info-grid { grid-template-columns: 1fr; }
  .receipt-header { flex-direction: column; align-items: flex-start; }
  .receipt-meta { align-items: flex-start; }
  .success-card { flex-direction: column; }
  .notice-banner { padding: 1.5rem 5%; }
}
</style>